<script setup lang="ts"></script>

<template>
  <div class="scrollbar-none scrollbar-none mb-4 flex overflow-auto text-sm">
    <slot></slot>
  </div>
</template>
